var React = require('react');

function IconCopyLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.90625 0.5H10.0572C10.3797 0.5 10.6895 0.629492 10.918 0.858008L12.642 2.58203C12.8705 2.81055 13 3.12031 13 3.44277V9.03125C13 9.7041 12.4541 10.25 11.7812 10.25H6.90625C6.2334 10.25 5.6875 9.7041 5.6875 9.03125V1.71875C5.6875 1.0459 6.2334 0.5 6.90625 0.5ZM1.21875 3.75H4.875V5.375H1.625V11.875H6.5V11.0625H8.125V12.2812C8.125 12.9541 7.5791 13.5 6.90625 13.5H1.21875C0.545898 13.5 0 12.9541 0 12.2812V4.96875C0 4.2959 0.545898 3.75 1.21875 3.75Z"}));
}

IconCopyLink.defaultProps = {"viewBox":"0 0 13 14","fill":"currentColor"};

module.exports = IconCopyLink;

IconCopyLink.default = IconCopyLink;
